"use client";

import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface HeroNavigationProps {
  onPrev: () => void;
  onNext: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

const HeroNavigation: React.FC<HeroNavigationProps> = ({
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
}) => {
  return (
    <>
      {/* Prev Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          onPrev();
        }}
        disabled={prevDisabled}
        className={`absolute left-3.5 top-1/2 -translate-y-1/2 z-10 
          hidden md:flex items-center justify-center w-9 h-9 rounded-full 
          bg-white/75 hover:bg-white text-[#0F1E36] shadow-sm transition-all duration-300 ease-out
          hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 
          focus-visible:ring-offset-2 focus-visible:ring-[#D97706] disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-5 h-5 stroke-[2.0]" />
      </button>

      {/* Next Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          onNext();
        }}
        disabled={nextDisabled}
        className={`absolute right-3.5 top-1/2 -translate-y-1/2 z-10 
          hidden md:flex items-center justify-center w-9 h-9 rounded-full 
          bg-white/75 hover:bg-white text-[#0F1E36] shadow-sm transition-all duration-300 ease-out
          hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 
          focus-visible:ring-offset-2 focus-visible:ring-[#D97706] disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="Next slide"
      >
        <ChevronRight className="w-5 h-5 stroke-[2.0]" />
      </button>
    </>
  );
};

export default React.memo(HeroNavigation);
